var exports = {
  "mc": "Container__aJzdKg",
  "PE": "Layout__kW5IKh",
  "QR": "Copy__2mEnRd",
  "VY": "Description__YsdYP_",
  "hE": "Title__POr4zB",
  "RO": "Cta__X5LoKD",
  "En": "Actions__zqd8r-",
  "pV": "Dismiss__OCvS_O",
  "qX": "HideOnMobile__qjdNh7",
  "KE": "HideOnTablet__zMX7IB",
};

module.exports = exports;
